import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const stockSetting = (state = initialState.stockManagement, action) => {
  let settingIndex
  let setting = []
  let grants = []

  switch (action.type) {
    case types.FETCH_STOCK_MANAGEMENT_SETTINGS_SUCCESS:
      return { ...state, stockSettings: action.payload }

    case types.CREATE_STOCK_MANAGEMENT_SETTINGS_SUCCESS:
      return {
        ...state,
        stockSettings: [...state.stockSettings, action.payload]
      }

    case types.UPDATE_STOCK_MANAGEMENT_SETTINGS_SUCCESS:
      settingIndex = state.stockSettings.findIndex((setting) => setting.id === action.payload.id)

      if (settingIndex) {
        setting = [...state.stockSettings]
        setting[settingIndex] = action.payload
      } else {
        setting = [...state.stockSettings, action.payload]
      }

      return { ...state, stockSettings: [...setting] }

    case types.FETCH_GRANT_SUCCESS:
      return { ...state, grants: action.payload['grants'], stats: action.payload['stats'] }

    case types.UPDATE_GRANT_SUCCESS:
      settingIndex = state.grants.findIndex((grant) => grant.id === action.payload.id)
      grants = [...state.grants]
      if (settingIndex !== -1) {
        grants[settingIndex] = action.payload
        state.stats[2].purchased = Number(state.stats[2].purchased) + Number(action.payload.purchased_grants)
        state.stats[0].vested = Number(state.stats[0].vested) - Number(action.payload.purchased_grants)
      }

      return { ...state, grants: [...grants] }

    case types.CREATE_GRANT_SUCCESS:
      settingIndex = state.stockSettings.findIndex((setting) => setting.id === action.payload.stock_setting_id)

      if (settingIndex !== -1) {
        setting = [...state.stockSettings]
        setting[settingIndex] = {
          ...setting[settingIndex],
          allocated_stocks_count: (setting[settingIndex].allocated_stocks_count || 0) + action.payload.number_of_shares
        }
      } else {
        setting = [...state.stockSettings]
      }

      return {
        ...state,
        grants: [...state.grants, action.payload],
        stockSettings: [...setting]
      }

    default:
      return state
  }
}
